import * as React from "react";

const GpsIcon = (props) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
    <path
      d="M12 8.5c-1.93 0-3.5 1.57-3.5 3.5s1.57 3.5 3.5 3.5 3.5-1.57 3.5-3.5-1.57-3.5-3.5-3.5Zm0 5c-.827 0-1.5-.673-1.5-1.5s.673-1.5 1.5-1.5 1.5.673 1.5 1.5-.673 1.5-1.5 1.5Z"
      fill="currentColor"
    />
    <path
      d="M23 11h-2.059A9.012 9.012 0 0 0 13 3.059V1a1 1 0 0 0-2 0v2.059A9.012 9.012 0 0 0 3.059 11H1a1 1 0 0 0 0 2h2.059A9.012 9.012 0 0 0 11 20.941V23a1 1 0 0 0 2 0v-2.059A9.012 9.012 0 0 0 20.941 13H23a1 1 0 0 0 0-2Zm-11 8c-3.86 0-7-3.14-7-7s3.14-7 7-7 7 3.14 7 7-3.14 7-7 7Z"
      fill="currentColor"
    />
  </svg>
);

export default GpsIcon;
